import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MiscService } from '../../_service/misc.service';
import { DentalService } from '../../_service/dental.service';
import { SharedService } from '../../_service/shared.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.css']
})
export class PaymentSummaryComponent implements OnInit {

  treatList=[]; start_date:string='';end_date:string='';sp_start_date:string='';sp_end_date:string='';bd_start_date:string='';bd_end_date:string='';circle_treatment='';sp_treatment='';bd_treatment='';

  /***********Circle Wise*********** */
  circle_wise_sales_payment_loading:boolean=false;performanceFieldSales = [];total_balance = 0;total_balance_payment=0;total_cash_count=0;total_cash_received=0;total_inside_sale=0;total_mtd_converted=0;total_mtd_revenue=0;total_mtd_sd=0;total_revenue_locked=0;total_lead_count=0;total_total_sb=0;
  /***********Scan pro Wise*********** */
  spro_wise_sales_payment_loading:boolean=false;spperformanceFieldSales=[];total_sp_balance = 0;total_sp_balance_payment=0;total_sp_cash_count=0;total_sp_cash_received=0;total_sp_inside_sale=0;total_sp_mtd_converted=0;total_sp_mtd_revenue=0;total_sp_mtd_sd=0;total_sp_revenue_locked=0;
  /***********BD Wise*********** */
  bd_wise_sales_payment_loading:boolean=false;bdperformanceFieldSales=[];total_bd_balance = 0;total_bd_balance_payment=0;total_bd_cash_count=0;total_bd_cash_received=0;total_bd_inside_sale=0;total_bd_mtd_converted=0;total_bd_mtd_revenue=0;total_bd_mtd_sd=0;total_bd_revenue_locked=0;total_bd_assigned_lead=0;total_bd_sb=0;total_sb_per=0;



  constructor(private dentalapi:DentalService,private sharedapi:SharedService,public miscapi:MiscService) {}
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  @ViewChild('dateRangeStart2', {static: false}) dateRangeStart2: ElementRef;
  @ViewChild('dateRangeEnd2', {static: false}) dateRangeEnd2: ElementRef;
  @ViewChild('dateRangeStart3', {static: false}) dateRangeStart3: ElementRef;
  @ViewChild('dateRangeEnd3', {static: false}) dateRangeEnd3: ElementRef;

  ngOnInit(): void {
    this.getTreatmentCategory();
    this.getCityWisePerformanceFieldSales();
    this.getScanProWisePerformanceFieldSales();
    this.getBDWisePerformanceFieldSales();
  }

  async getTreatmentCategory()
  {
      await this.miscapi.getDentalTraetment().subscribe((data:any) => {
          if(data.status)
          {
              this.treatList = data.data;
          }else{
              this.treatList = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getCityWisePerformanceFieldSales()
  {
    this.circle_wise_sales_payment_loading=true;
    this.performanceFieldSales = [];
    this.total_lead_count = 0;
    this.total_total_sb = 0;
    this.total_balance = 0;
    this.total_balance_payment=0;
    this.total_cash_count=0;
    this.total_cash_received=0;
    this.total_inside_sale=0;
    this.total_mtd_converted=0;
    this.total_mtd_revenue=0;
    this.total_mtd_sd=0;
    this.total_revenue_locked=0;
    let qString = 'date_range='+this.start_date+'-'+this.end_date+'&treatment='+this.circle_treatment;
    await this.dentalapi.getCityWisePerformanceFieldSalesPaymentSummary(qString).subscribe((data:any) => {
        this.circle_wise_sales_payment_loading=false;
        if(data.status)
        {
          this.performanceFieldSales = data.data;
          this.total_lead_count = this.performanceFieldSales.map(item => item.lead_count).reduce((prev, curr) => prev + curr, 0);
          this.total_total_sb = this.performanceFieldSales.map(item => item.total_sb).reduce((prev, curr) => prev + curr, 0);
          this.total_mtd_sd = this.performanceFieldSales.map(item => item.mtd_sd).reduce((prev, curr) => prev + curr, 0);
          this.total_mtd_converted = this.performanceFieldSales.map(item => item.mtd_converted).reduce((prev, curr) => prev + curr, 0);
          this.total_inside_sale = this.performanceFieldSales.map(item => item.inside_sale).reduce((prev, curr) => prev + curr, 0);
          this.total_revenue_locked = this.performanceFieldSales.map(item => Number(item.revenue_locked)).reduce((prev, curr) => prev + curr, 0);
          this.total_mtd_revenue = this.performanceFieldSales.map(item => Number(item.mtd_revenue)).reduce((prev, curr) => prev + curr, 0);
          this.total_cash_count = this.performanceFieldSales.map(item => Number(item.cash_count)).reduce((prev, curr) => prev + curr, 0);
          this.total_cash_received = this.performanceFieldSales.map(item => Number(item.cash_received)).reduce((prev, curr) => prev + curr, 0);
          this.total_balance_payment = this.performanceFieldSales.map(item => Number(item.balance_payment)).reduce((prev, curr) => prev + curr, 0);
          this.total_balance = this.total_balance_payment/this.total_revenue_locked;
        }else{
          this.performanceFieldSales = [];
          this.total_lead_count = 0;
          this.total_balance = 0;
          this.total_balance_payment=0;
          this.total_cash_count=0;
          this.total_cash_received=0;
          this.total_inside_sale=0;
          this.total_mtd_converted=0;
          this.total_mtd_revenue=0;
          this.total_mtd_sd=0;
          this.total_revenue_locked=0;
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  exportCircldeWisePerformanceField()
  {
    if(this.performanceFieldSales.length>0)
    {
      let data = [];
      let titles = [
        'Circle',
        'Total Leads',
        'Total SB',
        'MTD SD',
        'MTD Converted',
        'Inside Sale',
        'Revenue Locked',
        'MTD Revenue',
        'Cash Count',
        'Cash Received',
        'Balance Payment',
        'Balance %'
      ];
      data.push(titles);
      for(let pfSales in this.performanceFieldSales)
      {
        let exdata = [
          this.performanceFieldSales[pfSales].name,
          this.performanceFieldSales[pfSales].lead_count,
          this.performanceFieldSales[pfSales].total_sb,
          this.performanceFieldSales[pfSales].mtd_sd,
          this.performanceFieldSales[pfSales].mtd_converted,
          this.performanceFieldSales[pfSales].inside_sale,
          this.performanceFieldSales[pfSales].revenue_locked,
          this.performanceFieldSales[pfSales].mtd_revenue,
          this.performanceFieldSales[pfSales].cash_count,
          this.performanceFieldSales[pfSales].cash_received,
          this.performanceFieldSales[pfSales].balance_payment,
          parseFloat(this.performanceFieldSales[pfSales].balance).toFixed(2),
        ];
        data.push(exdata);
      }
      
      data.push(
        [
          'Total',
          this.total_lead_count,
          this.total_total_sb,
          this.total_mtd_sd,
          this.total_mtd_converted,
          this.total_inside_sale,
          this.total_revenue_locked,
          this.total_mtd_revenue,
          this.total_cash_count,
          this.total_cash_received,
          this.total_balance_payment,
          this.total_balance.toFixed(2)
        ]
      );
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
      XLSX.writeFile(wb, 'circle_wise_performance_field_sales_'+utc+'.xlsx');
    }
    else
    {
      this.sharedapi.presentToast('No Data Found');
    }
  }

  async getScanProWisePerformanceFieldSales()
  {
    this.spro_wise_sales_payment_loading=true;
    this.spperformanceFieldSales = [];
    this.total_sp_balance = 0;
    this.total_sp_balance_payment=0;
    this.total_sp_cash_count=0;
    this.total_sp_cash_received=0;
    this.total_sp_inside_sale=0;
    this.total_sp_mtd_converted=0;
    this.total_sp_mtd_revenue=0;
    this.total_sp_mtd_sd=0;
    this.total_sp_revenue_locked=0;
    let qString = 'date_range='+this.sp_start_date+'-'+this.sp_end_date+'&treatment='+this.sp_treatment;
    await this.dentalapi.getScanProWisePerformanceFieldSalesPaymentSummary(qString).subscribe((data:any) => {
      this.spro_wise_sales_payment_loading=false;
      if(data.status)
      {
        this.spperformanceFieldSales = data.data;
        this.total_sp_mtd_sd = this.spperformanceFieldSales.map(item => item.mtd_sd).reduce((prev, curr) => prev + curr, 0);
        this.total_sp_mtd_converted = this.spperformanceFieldSales.map(item => item.mtd_converted).reduce((prev, curr) => prev + curr, 0);
        this.total_sp_inside_sale = this.spperformanceFieldSales.map(item => item.inside_sale).reduce((prev, curr) => prev + curr, 0);
        this.total_sp_revenue_locked = this.spperformanceFieldSales.map(item => Number(item.revenue_locked)).reduce((prev, curr) => prev + curr, 0);
        this.total_sp_mtd_revenue = this.spperformanceFieldSales.map(item => Number(item.mtd_revenue)).reduce((prev, curr) => prev + curr, 0);
        this.total_sp_cash_count = this.spperformanceFieldSales.map(item => Number(item.cash_count)).reduce((prev, curr) => prev + curr, 0);
        this.total_sp_cash_received = this.spperformanceFieldSales.map(item => Number(item.cash_received)).reduce((prev, curr) => prev + curr, 0);
        this.total_sp_balance_payment = this.spperformanceFieldSales.map(item => Number(item.balance_payment)).reduce((prev, curr) => prev + curr, 0);
        this.total_sp_balance = this.total_sp_balance_payment/this.total_sp_revenue_locked;
      }else{
        this.spperformanceFieldSales = [];
        this.total_sp_balance = 0;
        this.total_sp_balance_payment=0;
        this.total_sp_cash_count=0;
        this.total_sp_cash_received=0;
        this.total_sp_inside_sale=0;
        this.total_sp_mtd_converted=0;
        this.total_sp_mtd_revenue=0;
        this.total_sp_mtd_sd=0;
        this.total_sp_revenue_locked=0;
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  exportProWisePerformanceField()
  {
    if(this.spperformanceFieldSales.length>0)
    {
      let data = [];
      let titles = [
        'Scan Pro User',
        'MTD SD',
        'MTD Converted',
        'Inside Sale',
        'Revenue Locked',
        'MTD Revenue',
        'Cash Count',
        'Cash Received',
        'Balance Payment',
        'Balance %'
      ];
      data.push(titles);
      for(let spfSales in this.spperformanceFieldSales)
      {
        let exdata = [
          this.spperformanceFieldSales[spfSales].name,
          this.spperformanceFieldSales[spfSales].mtd_sd,
          this.spperformanceFieldSales[spfSales].mtd_converted,
          this.spperformanceFieldSales[spfSales].inside_sale,
          this.spperformanceFieldSales[spfSales].revenue_locked,
          this.spperformanceFieldSales[spfSales].mtd_revenue,
          this.spperformanceFieldSales[spfSales].cash_count,
          this.spperformanceFieldSales[spfSales].cash_received,
          this.spperformanceFieldSales[spfSales].balance_payment,
          parseFloat(this.spperformanceFieldSales[spfSales].balance).toFixed(2),
        ];
        data.push(exdata);
      }
      
      data.push(
        [
          'Total',
          this.total_sp_mtd_sd,
          this.total_sp_mtd_converted,
          this.total_sp_inside_sale,
          this.total_sp_revenue_locked,
          this.total_sp_mtd_revenue,
          this.total_sp_cash_count,
          this.total_sp_cash_received,
          this.total_sp_balance_payment,
          this.total_sp_balance.toFixed(2)
        ]
      );
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
      XLSX.writeFile(wb, 'pro_wise_performance_field_sales_'+utc+'.xlsx');
    }
    else
    {
      this.sharedapi.presentToast('No Data Found');
    }
  }

  async getBDWisePerformanceFieldSales()
  {
    this.bd_wise_sales_payment_loading=true;
    this.bdperformanceFieldSales = [];
    this.total_bd_balance = 0;
    this.total_bd_balance_payment=0;
    this.total_bd_cash_count=0;
    this.total_bd_cash_received=0;
    this.total_bd_inside_sale=0;
    this.total_bd_mtd_converted=0;
    this.total_bd_mtd_revenue=0;
    this.total_bd_mtd_sd=0;
    this.total_bd_revenue_locked=0;
    this.total_bd_assigned_lead=0;
    this.total_bd_sb=0;
    this.total_sb_per=0;
    let qString = 'date_range='+this.bd_start_date+'-'+this.bd_end_date+'&treatment='+this.bd_treatment;
    await this.dentalapi.getBDWisePerformanceFieldSalesPaymentSummary(qString).subscribe((data:any) => {
      this.bd_wise_sales_payment_loading=false;
      if(data.status)
      {
        this.bdperformanceFieldSales = data.data;
        
        this.total_bd_assigned_lead = this.bdperformanceFieldSales.map(item => item.assigned_lead).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_sb = this.bdperformanceFieldSales.map(item => item.total_sb).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_mtd_sd = this.bdperformanceFieldSales.map(item => item.mtd_sd).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_mtd_converted = this.bdperformanceFieldSales.map(item => item.mtd_converted).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_inside_sale = this.bdperformanceFieldSales.map(item => item.inside_sale).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_revenue_locked = this.bdperformanceFieldSales.map(item => Number(item.revenue_locked)).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_mtd_revenue = this.bdperformanceFieldSales.map(item => Number(item.mtd_revenue)).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_cash_count = this.bdperformanceFieldSales.map(item => Number(item.cash_count)).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_cash_received = this.bdperformanceFieldSales.map(item => Number(item.cash_received)).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_balance_payment = this.bdperformanceFieldSales.map(item => Number(item.balance_payment)).reduce((prev, curr) => prev + curr, 0);
        this.total_bd_balance = this.total_bd_balance_payment/this.total_bd_revenue_locked;
        this.total_sb_per = this.total_bd_sb/this.total_bd_assigned_lead;


      }else{
        this.bdperformanceFieldSales = [];
        this.total_bd_balance = 0;
        this.total_bd_balance_payment=0;
        this.total_bd_cash_count=0;
        this.total_bd_cash_received=0;
        this.total_bd_inside_sale=0;
        this.total_bd_mtd_converted=0;
        this.total_bd_mtd_revenue=0;
        this.total_bd_mtd_sd=0;
        this.total_bd_revenue_locked=0;
        this.total_bd_assigned_lead=0;
        this.total_bd_sb=0;
        this.total_sb_per=0;
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  exportBDWisePerformanceField()
  {
    if(this.bdperformanceFieldSales.length>0)
    {
      let data = [];
      let titles = [
        'BD Name',
        'Lead Assigned',
        'Total SB',
        'MTD SD',
        'MTD Converted',
        'Inside Sale',
        'Revenue Locked',
        'MTD Revenue',
        'Cash Count',
        'Cash Received',
        'Balance Payment',
        'Balance %',
        'SB %'
      ];
      data.push(titles);
      for(let bdfSales in this.bdperformanceFieldSales)
      {
        let exdata = [
          this.bdperformanceFieldSales[bdfSales].name,
          this.bdperformanceFieldSales[bdfSales].assigned_lead,
          this.bdperformanceFieldSales[bdfSales].total_sb,
          this.bdperformanceFieldSales[bdfSales].mtd_sd,
          this.bdperformanceFieldSales[bdfSales].mtd_converted,
          this.bdperformanceFieldSales[bdfSales].inside_sale,
          this.bdperformanceFieldSales[bdfSales].revenue_locked,
          this.bdperformanceFieldSales[bdfSales].mtd_revenue,
          this.bdperformanceFieldSales[bdfSales].cash_count,
          this.bdperformanceFieldSales[bdfSales].cash_received,
          this.bdperformanceFieldSales[bdfSales].balance_payment,
          parseFloat(this.bdperformanceFieldSales[bdfSales].balance).toFixed(2),
          parseFloat(this.bdperformanceFieldSales[bdfSales].sb_per).toFixed(2),
        ];
        data.push(exdata);
      }
      
      data.push(
        [
          'Total',
          this.total_bd_assigned_lead,
          this.total_bd_sb,
          this.total_bd_mtd_sd,
          this.total_bd_mtd_converted,
          this.total_bd_inside_sale,
          this.total_bd_revenue_locked,
          this.total_bd_mtd_revenue,
          this.total_bd_cash_count,
          this.total_bd_cash_received,
          this.total_bd_balance_payment,
          this.total_bd_balance.toFixed(2),
          this.total_sb_per.toFixed(2)
        ]
      );
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
      XLSX.writeFile(wb, 'bd_wise_performance_field_sales_'+utc+'.xlsx');
    }
    else
    {
      this.sharedapi.presentToast('No Data Found');
    }
  }

  dateRangeChangecity(date1,date2)
  {
      if(date2.value)
      {
        this.start_date = date1.value;
        this.end_date = date2.value;
        this.getCityWisePerformanceFieldSales();
      }
  }
  dateRangeChangeSP(date1,date2)
  {
    if(date2.value)
    {
      this.sp_start_date = date1.value;
      this.sp_end_date = date2.value;
      this.getScanProWisePerformanceFieldSales();
    }
  }
  dateRangeChangeBD(date1,date2)
  {
    if(date2.value)
    {
      this.bd_start_date = date1.value;
      this.bd_end_date = date2.value;
      this.getBDWisePerformanceFieldSales();
    }
  }
  clearDate(type)
  {
      if(type==1){
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        this.getCityWisePerformanceFieldSales();
      }else if(type==2){
        this.dateRangeStart2.nativeElement.value = "";
        this.dateRangeEnd2.nativeElement.value = "";
        this.sp_start_date = '';
        this.sp_end_date = '';
        this.getScanProWisePerformanceFieldSales(); 
      }else if(type==3){
        this.dateRangeStart3.nativeElement.value = "";
        this.dateRangeEnd3.nativeElement.value = "";
        this.bd_start_date = "";
        this.bd_end_date = "";
        this.getBDWisePerformanceFieldSales();
      }
  }
}
